import menu from "magicbean-saas-common/src/core/language/zh/menu.json";
import common from "./common.json";
import merchants from "./merchants.json";

export default {
  menu,
  common,
  merchants,
};
